import { axios } from './config';

// 全流程安全生产-基础数据管理-组织架构-获取图片
export function getOrganization(params) {
  return axios.get('/companyorg/list_all', params, true);
}

// 全流程安全生产-基础数据管理-组织架构-新增图片
export function addOrganization(params) {
  return axios.post('/companyorg/save', params, true);
}

// 全流程安全生产-基础数据管理-组织架构-编辑图片
export function editOrganization(params) {
  return axios.post('/companyorg/update', params, true);
}

// 基础数据管理-获取车辆管理列表
export function getVehicleList(params) {
  return axios.get('/vehicleInformation/list_all', params, false)
}

// 基础数据管理-车辆新增
export function addVehicle(params) {
  return axios.post('/vehicleInformation/save', params, true)
}

// 基础数据管理- 获取所属部门(承包商)的下拉数据
export function getDepartmentList(params) {
  return axios.get('/contractorInfo/usableContractor', params, true)
}

// 基础数据管理-车辆信息编辑
export function editVehicle(params) {
  return axios.post('/vehicleInformation/update', params, true)
}

// 基础数据-车辆删除
export function deleteVehicle(params) {
  return axios.post(`/vehicleInformation/delete/${params}`, true)
}

// 基础数据-获取设备管理列表
export function getDeviceList(params) {
  return axios.get('/licensePlateCamera/list_all', params, true)
}

// 基础数据-设备新增
export function addDevice(params) {
  return axios.post('/licensePlateCamera/save', params, true)
}

// 基础数据-设备编辑
export function editDevice(params) {
  return axios.post('/licensePlateCamera/update', params, true)
}

// 基础数据-设备删除
export function deleteDevice(params) {
  return axios.post(`/licensePlateCamera/delete/${params}`, true)
}
